import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../components/Footer/Footer';
import './QuyDinh.css';

const QuyDinh: React.FC = () => {
  console.log('quy dinh');
  return (
    <div>
      <Helmet>
        <title>Quy định</title>

        <meta name="description" content="Quy định khi sử dụng pixel.io.vn" />

        {/* og */}
        <meta property="og:title" content="Quy định" />
        <meta
          property="og:description"
          content="Quy định khi sử dụng pixel.io.vn"
        />
        <meta property="og:image" content="/logo512.jpg" />
      </Helmet>

      <div className="quy-dinh">
        <h1>Quy Định</h1>

        <section className="quy-dinh-section">
          <h2>1. Giới Thiệu</h2>
          <ul>
            <li>
              Người dùng có thể mua các ô vuông này và tùy chỉnh màu sắc, thêm
              text mô tả và liên kết cho ô vuông đó.
            </li>
            <li>
              Từ 0 giờ ngày 20/07/2025, dự án bắt đầu, toàn bộ ô vuông được
              chỉnh sửa tự do.
            </li>
            <li>
              Từ 0 giờ ngày 20/08/2025, có thể mua các ô vuông để sỡ hữu vĩnh
              viễn.
            </li>
            <li>Từ ngày 0 giờ ngày 02/09/2025, ngừng tất cả mọi chỉnh sửa.</li>
            <li>
              Bản đồ phiên bản cuối cùng sẽ được lưu trữ vĩnh viễn với tên gọi
              "Bản đồ Pixel Việt Nam 2025"
            </li>
          </ul>
        </section>

        <section className="quy-dinh-section">
          <h2>2. Ô Vuông</h2>
          <ul>
            <li>Mỗi ô gồm 10x10 pixel = 100 ô pixel nhỏ</li>
            <li>
              Khi mua 1 ô vuông, người mua có thể tự do thiết kế màu sắc cho 100
              pixel này
            </li>
            <li>
              Mỗi ô vuông có thể đính kèm text mô tả ngắn (hiển thị khi click
              vào ô vuông)
            </li>
            <li>
              Mỗi ô vuông cũng có thể kèm một liên kết (mở khi click 2 lần vào
              cùng 1 ô vuông)
            </li>
          </ul>
        </section>

        <section className="quy-dinh-section">
          <h2>3. Kiểm duyệt nội Dung</h2>
          <h3>
            Toàn bộ nội dung (hình vẽ, text, link) phải tuân thủ các quy định
            sau
          </h3>
          <ul>
            <ul>
              <li>
                Tuân thủ pháp luật Việt Nam và các quy định pháp lý hiện hành.
              </li>
              <li>
                Phải phù hợp với thuần phong mỹ tục, văn hóa và đạo đức xã hội
                Việt Nam.
              </li>
              <li>
                Không kích động thù hận, phân biệt chủng tộc, giới tính, tôn
                giáo, vùng miền.
              </li>
              <li>
                Không xúc phạm, bôi nhọ, vu khống, công kích cá nhân hoặc tổ
                chức.
              </li>
              <li>Không vi phạm bản quyền, quyền sở hữu trí tuệ.</li>
              <li>
                Không đăng tải thông tin giả mạo, sai lệch, xuyên tạc sự thật.
              </li>
              <li>
                Liên kết không chứa virus, mã độc, hoặc dẫn đến trang web độc
                hại, đồi trụy, cờ bạc, ma túy, vũ khí, cá độ,...
              </li>
              <li>
                Quảng cáo, thương mại không chấp nhận bất kỳ sản phẩm hoặc dịch
                vụ bất hợp pháp.
              </li>
            </ul>
          </ul>

          <h3>Xử lý vi Phạm</h3>
          <ul>
            <li>
              Người dùng chịu trách nhiệm pháp lý hoàn toàn về nội dung mình
              đăng tải.
            </li>
            <li>
              Nền tảng có quyền kiểm duyệt và xoá nội dung vi phạm mà không cần
              thông báo trước.
            </li>
            <li>
              Các trường hợp vi phạm nghiêm trọng hoặc tái vi phạm có thể bị thu
              hồi quyền sỡ hữu ô vuông.
            </li>
            <li>Quyết định của tôi là quyết định cuối cùng.</li>
          </ul>
        </section>

        <section className="quy-dinh-section">
          <h2>4. Quyền Sở Hữu</h2>
          <ul>
            <li>Người mua có quyền sở hữu 1 hoặc nhiều ô vuông.</li>
            <li>Các ô vuông được mua sẽ được chỉnh sửa chỉ bởi chủ sở hữu.</li>
          </ul>
        </section>

        <section className="quy-dinh-section">
          <h2>5. Giới Hạn Trách Nhiệm</h2>
          <div>
            <p>
              Tôi cung cấp nền tảng để mọi người tự do sáng tạo. Tuy nhiên, tôi
              không chịu trách nhiệm về:
            </p>
            <ul>
              <li>Nội dung do người dùng tạo ra</li>
              <li>Liên kết bên ngoài từ các ô pixel</li>
              <li>Giao dịch tự phát giữa các người dùng</li>
              <li>Thiệt hại gián tiếp phát sinh từ việc sử dụng dịch vụ</li>
            </ul>
          </div>
        </section>

        <section className="quy-dinh-section">
          <h2>6. Bảo Mật Thông Tin</h2>
          <ul>
            <li>Thông tin của người dùng được bảo mật</li>
            <li>Cam kết không chia sẻ thông tin với bên thứ ba</li>
          </ul>
        </section>
        <section className="quy-dinh-section">
          <h2>7. Thay Đổi Quy Định</h2>
          <p>
            Tôi có quyền cập nhật quy định này khi cần thiết. Người dùng sẽ được
            thông báo trước khi có thay đổi quan trọng.
          </p>
        </section>
      </div>

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default QuyDinh;
